import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=065380da&scoped=true&"
import script from "./terminal.vue?vue&type=script&lang=js&"
export * from "./terminal.vue?vue&type=script&lang=js&"
import style0 from "./terminal.vue?vue&type=style&index=0&id=065380da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065380da",
  null
  
)

export default component.exports